import ChatIcon from '@heroicons/react/outline/esm/ChatIcon.js'
import { clsx } from 'clsx'

import { Member } from '@tribeplatform/gql-client/types'
import { T } from '@tribeplatform/react-components/i18n'
import { useRouter } from '@tribeplatform/react-sdk'
import { Button } from '@tribeplatform/react-ui-kit/Button'

import { generateNewChatPath } from '../../../utils/messaging.utils.js'
import type { StaticField } from '../../Views/types.js'

interface Props {
  member: Member
  highlighted: boolean
  stretchX: string
  authMember: Member
  fullWidth: boolean
  buttonVariant: StaticField['settings']['buttonVariant']
}
export const MessageButton = ({
  member,
  highlighted,
  stretchX,
  authMember,
  fullWidth,
  buttonVariant,
}: Props) => {
  const { Link } = useRouter()
  const showIcon = buttonVariant === 'icon' || buttonVariant === 'iconText'
  const showText = buttonVariant === 'text' || buttonVariant === 'iconText'

  return member?.authMemberProps?.canSendPrivateMessages &&
    member?.id !== authMember?.id ? (
    <div
      className={clsx(
        'empty:hidden space-y-2',
        highlighted && 'ring-2 rounded-sm ring-offset-surface ring-focused',
        stretchX,
      )}
    >
      <Button
        variant="outline"
        as={Link}
        href={generateNewChatPath(member)}
        className="flex-shrink-0"
        leadingIcon={showIcon ? <ChatIcon /> : null}
        fullWidth={fullWidth}
        onClick={e => e.stopPropagation()}
      >
        {showText ? (
          <T defaultMessage="Message" id="Member.ActionButton.Message" />
        ) : (
          ''
        )}
      </Button>
    </div>
  ) : null
}
